export const DEFAULT_PAYMENT_FEES_QUANTITY = 12;
export const BANKS = {
    BCP: "BCP",
    BBVA: "BBVA",
    SCOTIABANK: "SCOTIABANK",
    INTERBANK: "INTERBANK",
};
export const TYPE_ACCOUNTS = {
    MASTER: "MASTER",
    CURRENT: "CURRENT",
    SAVING: "SAVING",
    CARD: "CARD",
};

export const TYPE_ACCOUNT = [
    { label: "Corriente", value: TYPE_ACCOUNTS.CURRENT },
    { label: "Ahorros", value: TYPE_ACCOUNTS.SAVING },
];

export const MASTER_TYPE_ACCOUNT = [
    {
        label: "Maestra",
        value: TYPE_ACCOUNTS.MASTER,
    },
];

export const TYPE_BANK = [
    {
        label: "Banco de Crédito del Perú",
        value: BANKS.BCP,
    },
    {
        label: "BBVA Continental",
        value: BANKS.BBVA,
    },
    {
        label: "Scotiabank",
        value: BANKS.SCOTIABANK,
    },
    {
        label: "Interbank",
        value: BANKS.INTERBANK,
    },
];

export const PAYMENT_TYPES = {
    CREDIT_CARD: "CREDIT_CARD",
    BANK_ACCOUNT: "BANK_ACCOUNT",
};

export const PAYMENT_TYPES_LABELS = {
    [PAYMENT_TYPES.CREDIT_CARD]: "Tarjeta",
    [PAYMENT_TYPES.BANK_ACCOUNT]: "Cargo a cuenta",
};

export const BANK_CODES = {
    [BANKS.BBVA]: "11",
    [BANKS.BCP]: "02",
    [BANKS.INTERBANK]: "03",
    [BANKS.SCOTIABANK]: "09",
};

export const TYPE_ACCOUNT_CODES = {
    [TYPE_ACCOUNTS.SAVING]: "A",
    [TYPE_ACCOUNTS.CURRENT]: "C",
    [TYPE_ACCOUNTS.MASTER]: "M",
    [TYPE_ACCOUNTS.MASTER]: "T",
};
